// LoadingButton.js
import React from 'react';

function LoadingButton({ children, isLoading, loadingText, className, ...props }) {
  return (
    <button
      className={className}
      disabled={isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <div className="h-4 w-4 border-2 border-current border-t-transparent rounded-full animate-spin mr-2"></div>
          {loadingText}
        </>
      ) : (
        children
      )}
    </button>
  );
}

export default LoadingButton;